import junePic from "@/public/images/artists/june.jpg";
import { Artist } from "@/types/types";

export const june = {
  id: "108",
  name: "June",
  image: junePic,
  description: `June possesses a remarkable vocal range that effortlessly traverses the airy heights of jazz and soul melodies, spanning from delicate whispers to powerful crescendos. Her voice exudes an organic warmth, drawing listeners into her emotive storytelling.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjune-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Soul", "Blues", "Jazz", "Airy"],
      secondary: ["Singer", "Organic", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 57,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
